import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const HeaderContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#0B3095",
  padding: "1rem 2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("sm")]: {
    padding: "1rem",
  },
}));

export const HeaderLogoImage = styled("img")(({ theme }) => ({
  margin: "0 auto",
  width: 200,
  height: "auto",
  [theme.breakpoints.down("sm")]: {
    width: 150,
  },
}));
